import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  progress: {
    margin: theme.spacing.unit * 2,
	height: '20px',
	width: '20px'
  },
});

function Loading (props) {
  const { classes, text } = props;
  return (
    <div>
      
      <CircularProgress className={classes.progress} />
      {text}
    </div>
  );
}

Loading.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Loading)


// WEBPACK FOOTER //
// ./src/Container/Loading/Loading.js